var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUldmapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 44,
    viewBox: "0 0 74 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 44.203V35.5835H40.537V44.203H33.839V40.842H23.6175V44.203H16.9195V40.842H6.698V44.203H0ZM8.8685 31.0585C8.14717 31.0585 7.52867 30.8007 7.013 30.285C6.497 29.769 6.239 29.1503 6.239 28.429V5.629C6.239 4.90766 6.497 4.28917 7.013 3.7735C7.52867 3.25783 8.14717 3 8.8685 3H31.6685C32.3898 3 33.0083 3.25783 33.524 3.7735C34.04 4.28917 34.298 4.90766 34.298 5.629V29.029C34.298 29.5803 34.0975 30.0565 33.6965 30.4575C33.2958 30.8582 32.8198 31.0585 32.2685 31.0585H8.8685ZM13.511 15.53H27.026V10.2715H13.511V15.53Z",
    fill: "#092B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5371 44.203V35.5835H74.0741V44.203H67.3761V40.842H57.1546V44.203H50.4566V40.842H40.2351V44.203H33.5371ZM42.4056 31.0585C41.6843 31.0585 41.0658 30.8007 40.5501 30.285C40.0341 29.769 39.7761 29.1503 39.7761 28.429V5.629C39.7761 4.90766 40.0341 4.28917 40.5501 3.7735C41.0658 3.25783 41.6843 3 42.4056 3H65.2056C65.9269 3 66.5454 3.25783 67.0611 3.7735C67.5771 4.28917 67.8351 4.90766 67.8351 5.629V29.029C67.8351 29.5803 67.6346 30.0565 67.2336 30.4575C66.8329 30.8582 66.3569 31.0585 65.8056 31.0585H42.4056ZM47.0481 15.53H60.5631V10.2715H47.0481V15.53Z",
    fill: "#092B4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUldmapping);
export default __webpack_public_path__ + "static/media/uldmapping.bcc2d1b5be7060418e64dd3b133b0d65.svg";
export { ForwardRef as ReactComponent };